import { browser } from '$app/environment';
import { awsInit } from '$lib/aws/aws-init';
import { useLocalCache } from '$lib/local-cache/local-cache';
import { GRAPHQL_AUTH_MODE, type GraphQLQuery } from '@aws-amplify/api';
import { API } from 'aws-amplify';
import { derived, writable } from 'svelte/store';

awsInit();

// leave undefined under, we need check at layout
const allTimezones = writable<AllTimezone[]>();

// make version where id is name, use for dropdown
const allTimezoneItems = derived(allTimezones, (l) => {
	return l.map((tz) => {
		return {
			...tz,
			id: tz.name,
			dbId: tz.id
		};
	});
});

export const useAllTimezones = () => {
	return { allTimezones, allTimezoneItems };
};

export interface AllTimezone {
	id: number;
	name: string;
	abbrev: string;
	isDst: boolean;
	utcOffset: {
		seconds?: number;
		hours?: number;
		days?: number;
		months?: number;
		years?: number;
	};
}

if (browser) {
	const lc = useLocalCache<AllTimezone[]>('chessat3-all-timezones', 1000 * 60 * 60 * 24);

	const lcd = lc.invoke();

	if (lcd) {
		allTimezones.set(lcd);
	} else {
		API.graphql<GraphQLQuery<any>>({
			query: /* GraphQL */ `
				query AllVwTimezoneNames(
					$first: Int
					$last: Int
					$offset: Int
					$before: String
					$after: String
					$orderBy: [VwTimezoneNamesOrderBy!]
					$condition: VwTimezoneNameCondition
					$filter: VwTimezoneNameFilter
				) {
					allVwTimezoneNames(
						first: $first
						last: $last
						offset: $offset
						before: $before
						after: $after
						orderBy: $orderBy
						condition: $condition
						filter: $filter
					) {
						nodes {
							id
							name
							abbrev
							isDst
						}
					}
				}
			`,
			variables: { filter: { abbrev: { _is_null: false } } },
			authMode: GRAPHQL_AUTH_MODE.API_KEY
		}).then((d) => {
			const items = d.data?.allVwTimezoneNames?.nodes ?? [];

			// todo: better catching
			if (d.errors?.length) {
				console.error(d.errors[0]);
				allTimezones.set(items);
			} else {
				allTimezones.set(items);
				lc.set(items);
			}
		});
	}
}
